import { IFormHandler } from "./forms";
import { convertAmountToFloat } from "../helpers/transaction_helpers";
import { Currency } from "../config/currencies";
import { AllowanceFrequency, IAllowance } from "../config/allowance";

export interface IAllowanceForm {
    name: string;
    amount: string;
    currency: Currency;
    frequency: AllowanceFrequency;
    max_per_frequency: string;
}

export interface IAllowanceRequest {
    name: string;
    amount: number;
    currency: Currency;
    frequency: AllowanceFrequency;
    max_per_frequency: number;
}

export class AllowanceForm implements IFormHandler<IAllowanceForm, IAllowanceRequest> {
    private readonly defaultCurrency: Currency;

    public readonly initialValue: IAllowanceForm;

    constructor(defaultCurrency: Currency, data?: IAllowance) {
        this.defaultCurrency = defaultCurrency;
        this.initialValue = this.toForm(data);
    }

    toForm(data?: IAllowanceRequest): IAllowanceForm {
        if (!data) {
            return {
                name: '',
                amount: '',
                currency: this.defaultCurrency,
                frequency: AllowanceFrequency.DAILY,
                max_per_frequency: '',
            };
        }

        return {
            name: data.name,
            amount: data.amount.toString(),
            currency: data.currency,
            frequency: data.frequency,
            max_per_frequency: data.max_per_frequency.toString(),
        };
    }

    toRequest(data: IAllowanceForm): IAllowanceRequest {
        return {
            name: data.name,
            amount: convertAmountToFloat(data.amount),
            currency: data.currency,
            frequency: data.frequency,
            max_per_frequency: parseInt(data.max_per_frequency)
        };
    }
}
